export const tr = {
    'amnesty-price': 'Gerçekleşen fiyat',
    bid: 'Teklif',
    'bid-forecast': 'Trafik tahmini',
    'low-shows-warning': 'Bu teklifle aramada çok az sayıda gösterim gerçekleşmesi bekleniyor.'
};
